import { useAtom, WritableAtom } from 'jotai';
import { SetStateAction } from 'react';
import { FilterChip } from './FilterChip';

type ProductCodesChipsProps = {
  productCodesAtom: WritableAtom<(string | null)[], [SetStateAction<(string | null)[]>], void>;
};

export const ProductCodesChips = ({ productCodesAtom }: ProductCodesChipsProps) => {
  const [productCodes, setProductCodes] = useAtom(productCodesAtom);

  const onClear = (id: string | null) => {
    setProductCodes((currentProductCodes) =>
      currentProductCodes.filter((productCode) => productCode !== id),
    );
  };

  return (
    <>
      {productCodes.map((productCode) => {
        if (productCode === null) {
          return (
            <FilterChip
              key={productCode}
              text="Product Code: blank"
              onClose={() => {
                onClear(productCode);
              }}
            />
          );
        }

        return (
          <FilterChip
            key={productCode}
            text={`Product Code: ${productCode}`}
            onClose={() => {
              onClear(productCode);
            }}
          />
        );
      })}
    </>
  );
};
